import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import SegmentacaoPublicoProvider from "./SegmentacaoPublicoContext";
import PesquisarSegmentacaoPublico from "./Events/PesquisarSegmentacaoPublico";
import FormularioSegmentacaoPublico from "./Events/FormularioSegmentacaoPublico";

const Index = () => {
  let match = useRouteMatch();
  return (
    <SegmentacaoPublicoProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarSegmentacaoPublico}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioSegmentacaoPublico}
          />
        </Switch>
      </div>
    </SegmentacaoPublicoProvider>
  );
};

export default Index;
